<div
  class="home-page__header"
  [style.transform]="'translateY(-' + headerTranslateY + 'px)'"
  [style.opacity]="headerOpacity"
  [style.pointer-events]="headerOpacity <= 0.05 ? 'none' : 'auto'"
>
  <div class="home-page__header__top">
    <div class="home-page__header-user" (click)="profileClick.emit()">
      <app-default-image
        [src]="userData?.image"
        [name]="userFullName"
        [cssClass]="'circle'"
        [width]="'40px'"
        [height]="'40px'"
        [alt]="'Photo de profil'"
        [letterSpacing]="'1px'"
        [showInitials]="shouldShowInitials"
      ></app-default-image>
      <div class="home-page__header-user-text">
        <p class="home-page__header-greeting">
          {{ "CLIENT_PAGE.WELCOME" | translate }}
        </p>
        <h1 class="home-page__header-name">
          {{ userData?.first_name }} {{ userData?.last_name }}
        </h1>
      </div>
    </div>

    <div class="home-page__header-actions">
      <button
        class="home-page__header-btn"
        type="button"
        (click)="notificationsClick.emit()"
      >
        <ion-icon name="notifications-outline"></ion-icon>
        <span class="home-page__header-btn-badge" *ngIf="hasUnreadNotifications"></span>
      </button>
      <button
        class="home-page__header-btn"
        type="button"
        (click)="configurationsClick.emit()"
      >
        <ion-icon name="settings-outline"></ion-icon>
      </button>
    </div>
  </div>

  <div class="home-page__header__adresses">
    <app-header-location-button
      [adressMessage]="adressMessage"
      (pressed)="locationClick.emit()"
    ></app-header-location-button>
  </div>

  <div class="home-page__header__search-grid">
    <app-header-search-button
      [searchPlaceholder]="searchPlaceholder"
      (searchInput)="onSearch($event)"
    ></app-header-search-button>
  </div>
</div>
